import React from "react";

export const nlToBr = (text: string) =>
  (text || "").split("\n").map((l, index) => (
    <React.Fragment key={index}>
      {l}
      <br />
    </React.Fragment>
  ));

export const getCopy = (url: string | undefined, alt: string | undefined) => {
  // * Captures everything after url to get name
  const regX = /[^ /\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/;
  let found = '';
  let source = 'Unsplash '

  if (alt) {
    let match = alt.match(regX);

    if (match && match.length > 0) {
      found = match[0]?.replace(/.(jpg|png|jpeg)$/i, '');
    }

    if (/(unsplash)/.test(found)) {
      found = source + found.replace(/(unsplash)/ig, '');
    }
  } else {
    if (url) {
      found = found.replace(/.*\/([^/]+)$/, '$1').replace(/-/g, ' ');
    }
  }

  found = found.replace(/-/g, ' ').replace(/\s+\w+\s$/, '').replace(/(scaled|photo|copy|image)/ig, '');

  if (!/[a-zA-Z]/.test(found)) {
    found = '';
  }

  return found;
}
